(function(){
  if (window.__AVNT_PRODUCT_ZOOM_V12__) return;
  window.__AVNT_PRODUCT_ZOOM_V12__ = true;

  function isProductPage(){ return !!document.querySelector('media-gallery, .product__media-wrapper, .product__media-list, [id^="ProductInfo-"]'); }

  function upgradeShopifyImageUrl(url){
    if(!url) return '';
    try { url = String(url); } catch(e) { return ''; }
    url = url.replace(/_(\d+)x(\d+)?(?=\.(jpg|jpeg|png|webp|gif)(\?|$))/i, '_4096x');
    url = url.replace(/_(\d+)x(?=\.(jpg|jpeg|png|webp|gif)(\?|$))/i, '_4096x');
    url = url.replace(/([?&])width=\d+/i, '$1width=4096');
    if(url.indexOf('width=') === -1 && (url.indexOf('/cdn/shop/') > -1 || url.indexOf('cdn.shopify.com') > -1)) url += (url.indexOf('?') > -1 ? '&' : '?') + 'width=4096';
    return url;
  }

  function bestFromSrcset(img){
    var srcset = img && img.getAttribute('srcset'); if(!srcset) return '';
    var best = '', bestW = 0;
    srcset.split(',').forEach(function(part){
      var bits = part.trim().split(/\s+/); if(!bits[0]) return;
      var w = bits[1] ? parseInt(bits[1].replace(/[^0-9]/g,''),10) || 0 : 0;
      if(w >= bestW){ bestW = w; best = bits[0]; }
    });
    return best;
  }

  function getHighRes(img){ return img ? upgradeShopifyImageUrl(img.getAttribute('data-zoom-image') || img.getAttribute('data-zoom') || bestFromSrcset(img) || img.currentSrc || img.src) : ''; }

  function getMediaIdFromElement(el){
    if(!el || !el.closest) return '';
    var thumb = el.closest('[data-target]'); if(thumb) return thumb.getAttribute('data-target') || '';
    var media = el.closest('[data-media-id]'); if(media) return media.getAttribute('data-media-id') || '';
    return '';
  }

  function normalizeMediaId(id){
    id = (id || '').toString();
    id = id.replace(/^#/, '').replace(/^Slide-/, '').replace(/^Thumbnail-/, '').replace(/^ProductModal-/, '');
    var nums = id.match(/(\d{6,})/g);
    return nums && nums.length ? nums[nums.length - 1] : id;
  }

  function normalizeImageKey(src, mediaId){
    var id = normalizeMediaId(mediaId);
    if(id) return 'media:' + id;
    src = (src || '').toString().split('?')[0];
    src = src.replace(/_\d+x\d*(?=\.(jpg|jpeg|png|webp|gif)$)/i, '');
    src = src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.(jpg|jpeg|png|webp|gif)$)/i, '');
    return 'src:' + src;
  }

  function findMainImageFromThumbnail(target){
    var mediaId = getMediaIdFromElement(target); if(!mediaId) return null;
    var escaped = (window.CSS && CSS.escape) ? CSS.escape(mediaId) : mediaId.replace(/"/g,'\\"');
    var main = document.querySelector('.product__media-list [data-media-id="' + escaped + '"] img, [id^="Slider-Gallery"] [data-media-id="' + escaped + '"] img');
    return main || (target.closest('[data-target]') && target.closest('[data-target]').querySelector('img'));
  }

  function getGalleryImages(){
    var seen = {}, items = [];
    var selectors = [
      '.product__media-list [data-media-id] img',
      '[id^="Slider-Gallery"] [data-media-id] img',
      'media-gallery .product__media img',
      '.product__media-wrapper .product__media img'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(img){
      var mediaId = getMediaIdFromElement(img);
      var src = getHighRes(img);
      var key = normalizeImageKey(src, mediaId);
      if(!src || seen[key]) return;
      seen[key] = true;
      items.push({ src: src, alt: img.alt || 'Product image', mediaId: normalizeMediaId(mediaId) });
    });
    if(!items.length){
      document.querySelectorAll('media-gallery img, .product__media-wrapper img').forEach(function(img){
        var mediaId = getMediaIdFromElement(img);
        var src = getHighRes(img);
        var key = normalizeImageKey(src, mediaId);
        if(!src || seen[key]) return;
        seen[key] = true;
        items.push({ src: src, alt: img.alt || 'Product image', mediaId: normalizeMediaId(mediaId) });
      });
    }
    return items;
  }

  function getClickedProductImage(target){
    if(!target || !target.closest || !isProductPage()) return null;
    if(target.closest('.avnt-zoom-overlay, .avnt-zoom-close, .avnt-zoom-toolbar, .avnt-zoom-nav')) return null;
    if(target.closest('.slider-button, .slider-counter, .shopify-payment-button, form[action*="/cart/add"], .product-form')) return null;
    var thumbImg = findMainImageFromThumbnail(target); if(thumbImg) return thumbImg;
    var img = target.closest('img');
    if(img && img.closest('media-gallery, .product__media-wrapper, .product__media-list, .product__media-gallery')) return img;
    var holder = target.closest('modal-opener.product__modal-opener, .product__modal-opener, .product__media, .product__media-item, media-gallery [data-media-id], .thumbnail-list__item');
    return holder ? holder.querySelector('img') : null;
  }

  function buildOverlay(){
    var overlay = document.createElement('div');
    overlay.className = 'avnt-zoom-overlay';
    overlay.innerHTML = '<button type="button" class="avnt-zoom-close" aria-label="Close image">×</button><button type="button" class="avnt-zoom-nav avnt-zoom-prev" aria-label="Previous image">‹</button><button type="button" class="avnt-zoom-nav avnt-zoom-next" aria-label="Next image">›</button><div class="avnt-zoom-toolbar"><button type="button" class="avnt-zoom-in" aria-label="Zoom in">+</button><button type="button" class="avnt-zoom-out" aria-label="Zoom out">−</button><button type="button" class="avnt-zoom-reset" aria-label="Reset zoom">Reset</button></div><div class="avnt-zoom-stage"><img class="avnt-zoom-img" alt="Product image" draggable="false"></div><div class="avnt-zoom-counter" aria-live="polite"></div><div class="avnt-zoom-help">Swipe for more photos. Pinch or double-tap to zoom. Drag to inspect fine details.</div>';
    document.body.appendChild(overlay); return overlay;
  }

  var overlay, stage, zoomImg, counter, gallery = [], currentIndex = 0;
  var scale = 1, x = 0, y = 0, startX = 0, startY = 0, lastX = 0, lastY = 0, dragging = false;
  var pinchStartDist = 0, pinchStartScale = 1, lastTap = 0, swipeStartX = 0, swipeStartY = 0;
  function clamp(v){ return Math.max(1, Math.min(10, v)); }
  function apply(){ if(zoomImg) zoomImg.style.transform = 'translate3d('+x+'px,'+y+'px,0) scale('+scale+')'; }
  function reset(){ scale = 1; x = 0; y = 0; apply(); }
  function distance(a,b){ var dx=a.clientX-b.clientX, dy=a.clientY-b.clientY; return Math.sqrt(dx*dx+dy*dy); }
  function updateCounter(){ if(counter) counter.textContent = gallery.length > 1 ? (currentIndex + 1) + ' / ' + gallery.length : ''; if(overlay) overlay.classList.toggle('avnt-single-image', gallery.length <= 1); }
  function preloadAdjacent(){ if(gallery.length <= 1) return; [currentIndex+1,currentIndex-1].forEach(function(i){ if(i<0)i=gallery.length-1; if(i>=gallery.length)i=0; var im=new Image(); im.src=gallery[i].src; }); }
  function showIndex(index){ if(!gallery.length) return; if(index<0)index=gallery.length-1; if(index>=gallery.length)index=0; currentIndex=index; var item=gallery[currentIndex]; zoomImg.src=item.src; zoomImg.alt=item.alt||'Product image'; reset(); updateCounter(); preloadAdjacent(); }
  function openZoom(img){
    var src = getHighRes(img); if(!src) return;
    overlay = overlay || buildOverlay(); stage = overlay.querySelector('.avnt-zoom-stage'); zoomImg = overlay.querySelector('.avnt-zoom-img'); counter = overlay.querySelector('.avnt-zoom-counter');
    gallery = getGalleryImages(); currentIndex = gallery.findIndex(function(item){ return item.src === src || item.mediaId === normalizeMediaId(getMediaIdFromElement(img)); });
    if(currentIndex < 0){ gallery.unshift({src: src, alt: img.alt || 'Product image', mediaId: normalizeMediaId(getMediaIdFromElement(img))}); currentIndex = 0; }
    overlay.classList.add('is-open'); document.documentElement.classList.add('avnt-zoom-locked'); document.body.classList.add('avnt-zoom-locked'); showIndex(currentIndex);
  }
  function closeZoom(){ if(!overlay) return; overlay.classList.remove('is-open'); document.documentElement.classList.remove('avnt-zoom-locked'); document.body.classList.remove('avnt-zoom-locked'); if(zoomImg) zoomImg.removeAttribute('src'); }
  function next(){ showIndex(currentIndex + 1); }
  function prev(){ showIndex(currentIndex - 1); }
  function handleOpen(e){ var img = getClickedProductImage(e.target); if(!img) return; e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); openZoom(img); }
  document.addEventListener('click', handleOpen, true);
  document.addEventListener('pointerup', function(e){ if(e.pointerType === 'mouse') return; handleOpen(e); }, {capture:true, passive:false});
  document.addEventListener('click', function(e){
    if(!overlay || !overlay.classList.contains('is-open')) return;
    if(e.target.closest('.avnt-zoom-close')) return closeZoom();
    if(e.target.closest('.avnt-zoom-next')) return next();
    if(e.target.closest('.avnt-zoom-prev')) return prev();
    if(e.target.closest('.avnt-zoom-in')) { scale = clamp(scale + .75); apply(); return; }
    if(e.target.closest('.avnt-zoom-out')) { scale = clamp(scale - .75); if(scale === 1){x=0;y=0;} apply(); return; }
    if(e.target.closest('.avnt-zoom-reset')) return reset();
    if(e.target === overlay) closeZoom();
  });
  document.addEventListener('keydown', function(e){ if(!overlay || !overlay.classList.contains('is-open')) return; if(e.key === 'Escape') closeZoom(); if(e.key === 'ArrowRight') next(); if(e.key === 'ArrowLeft') prev(); });
  document.addEventListener('touchstart', function(e){
    if(!overlay || !overlay.classList.contains('is-open') || !e.target.closest('.avnt-zoom-stage')) return;
    if(e.touches.length === 1){ swipeStartX=e.touches[0].clientX; swipeStartY=e.touches[0].clientY; var now=Date.now(); if(now-lastTap<300){ scale=scale>1?1:3; if(scale===1){x=0;y=0;} apply(); e.preventDefault(); } lastTap=now; dragging=true; startX=e.touches[0].clientX; startY=e.touches[0].clientY; lastX=x; lastY=y; }
    else if(e.touches.length === 2){ dragging=false; pinchStartDist=distance(e.touches[0],e.touches[1]); pinchStartScale=scale; }
  }, {passive:false});
  document.addEventListener('touchmove', function(e){
    if(!overlay || !overlay.classList.contains('is-open') || !e.target.closest('.avnt-zoom-stage')) return; e.preventDefault();
    if(e.touches.length === 2 && pinchStartDist){ scale=clamp(pinchStartScale*(distance(e.touches[0],e.touches[1])/pinchStartDist)); apply(); }
    else if(e.touches.length === 1 && dragging && scale > 1){ x=lastX+(e.touches[0].clientX-startX); y=lastY+(e.touches[0].clientY-startY); apply(); }
  }, {passive:false});
  document.addEventListener('touchend', function(e){
    if(overlay && overlay.classList.contains('is-open') && scale === 1 && swipeStartX){ var touch=(e.changedTouches&&e.changedTouches[0])||null; if(touch){ var dx=touch.clientX-swipeStartX, dy=touch.clientY-swipeStartY; if(Math.abs(dx)>55 && Math.abs(dx)>Math.abs(dy)*1.5){ if(dx<0) next(); else prev(); } } }
    dragging=false; pinchStartDist=0; swipeStartX=0; swipeStartY=0;
  }, {passive:true});
})();
